var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBubbleTailBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 10,
    viewBox: "0 0 17 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 1,
    stdDeviation: 1,
    floodColor: "rgba(0, 0, 0, 0.04)"
  }), /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 4,
    stdDeviation: 4,
    floodColor: "rgba(0, 0, 0, 0.08)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.08579 6.58579L0.5 0H16.5L9.91421 6.58579C9.13317 7.36684 7.86684 7.36684 7.08579 6.58579Z",
    fill: "#FAFAFA",
    filter: "url(#shadow)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbleTailBottom);
export default __webpack_public_path__ + "static/media/bubble-tail-bottom.751d3a6c52414fb7b9ea409f0b45cae2.svg";
export { ForwardRef as ReactComponent };